import React from 'react';
import { Grid } from '@mui/material';
import Placeholder from './Placholder';
import { PageTitleWithToolTip, BreadCrumbs } from '../Common';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import "./PowerBI.css"

const ReportContainer = ({
    trakrefReports,
    selectReportName,
    breadCrumbs,
    rls,
    selectedReport,
}) => {

    const pageTitle = (
        <PageTitleWithToolTip
            pageTitle={selectedReport.name ? selectReportName : trakrefReports ? 'Reports' : 'BI Dashboard'}
            toolTipText={
                (trakrefReports && !selectedReport.name)
                ? `These are the original reports we offer to all customers; they are static and rarely change.`
                : selectedReport.name
                ? ""
                : `Powered by Microsoft Power BI, this is where Trakref hosts many customer-specific reports.
                These reports are dynamic and may change based on customers and requests.`
            }
        />
    );

    return (
    <div style={{ marginTop: '-3%' }}>
        <BreadCrumbs
            path={breadCrumbs}
        />
        <Grid container>
            {selectedReport.isPowerBI && (
                <Grid item xs={12} md={12} lg={12}>
                    {pageTitle}
                </Grid>
            )}

            <Grid item xs={12} md={12} lg={12}>
                {!selectedReport.id && (
                    <Placeholder />
                )}

                {selectedReport.isPowerBI && !selectedReport.accessToken && (
                    <Grid item xs={12} md={12} lg={12} sx={{ marginTop: '2%' }}>
                        This report could not be loaded. Please try again later.
                    </Grid>
                )}

                {selectedReport.isPowerBI && selectedReport.accessToken && (
                <Grid item xs={12} md={12} lg={12} sx={{ marginTop: '2%' }}>
                    <PowerBIEmbed
                        key={selectedReport.key}
                        cssClassName="powerBIPanel"
                        embedConfig={{
                            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                            id: selectedReport.reportId,
                            embedUrl: selectedReport.embedUrl,
                            accessToken: selectedReport.accessToken,
                            tokenType: models.TokenType.Embed,
                            settings: {
                                panes: {
                                    filters: {
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: true,
                                        position: 1
                                    }
                                },
                            }
                        }}
                        eventHandlers={
                            new Map([
                                ['loaded', function () { console.log('Report loaded'); }],
                                ['rendered', function () { console.log('Report rendered'); }],
                                ['error', function (event) { console.log(event.detail); }]
                            ])
                        }
                    />
                </Grid>
                )}
            </Grid>
        </Grid>
    </div>
)};

export default ReportContainer;
